/*
  Garde-fou panier — produits numériques à exemplaire unique.
  Règle : quantité max = 1 par produit, Pack et guides individuels mutuellement exclusifs.
  Expose window.BHCart.normalize()/refreshBadge()/fetchCart(), appelé après chaque mutation
  du panier (ajout, swap pop-up) et au chargement de /cart. Rendu une seule fois, site-wide,
  depuis layout/theme.liquid — donc chargé avant tout script inline de section qui en dépend.
*/
window.BHCart = (function () {
  var PACK_HANDLE = 'le-pack-complet-3-guides-cadeaux';
  // Anciens et nouveaux handles : les guides ont ete renommes le 19/07/2026. Shopify redirige
  // les URL mais pas les comparaisons de chaines, et un ancien lien peut encore circuler
  // (favori, historique, lien partage). Les deux series restent donc reconnues.
  var SOLO_HANDLES = [
    'body-reset-guide-mouvement',
    'glow-all-year-guide-peau',
    'eat-stay-balanced-guide-nutrition',
    'body-summer-reset-guide-mouvement',
    'glow-all-summer-guide-peau',
    'eat-stay-lean-guide-nutrition'
  ];

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function paintBadge(cart) {
    document.querySelectorAll('[data-bh-cart-count]').forEach(function (el) {
      var label = el.getAttribute('data-bh-cart-label') || 'Panier';
      el.textContent = label + ' (' + cart.item_count + ')';
    });
  }

  function refreshBadge(cart) {
    if (cart) {
      paintBadge(cart);
      return Promise.resolve(cart);
    }
    return fetchCart().then(function (c) {
      paintBadge(c);
      return c;
    });
  }

  function normalize(cart) {
    return (cart ? Promise.resolve(cart) : fetchCart()).then(function (c) {
      var hasPack = c.items.some(function (it) { return it.handle === PACK_HANDLE; });
      var updates = {};
      var removedDuplicates = false;
      var clampedQuantity = false;

      c.items.forEach(function (it) {
        if (hasPack && SOLO_HANDLES.indexOf(it.handle) !== -1) {
          updates[it.key] = 0;
          removedDuplicates = true;
        } else if (it.quantity > 1) {
          updates[it.key] = 1;
          clampedQuantity = true;
        }
      });

      if (!removedDuplicates && !clampedQuantity) {
        return refreshBadge(c).then(function () {
          return { cart: c, changed: false, removedDuplicates: false, clampedQuantity: false };
        });
      }

      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (r) { return r.json(); })
        .then(function (newCart) {
          return refreshBadge(newCart).then(function () {
            return {
              cart: newCart,
              changed: true,
              removedDuplicates: removedDuplicates,
              clampedQuantity: clampedQuantity
            };
          });
        });
    });
  }

  function swapToPack(packVariantId) {
    return fetchCart()
      .then(function (cart) {
        var updates = {};
        cart.items.forEach(function (it) {
          if (SOLO_HANDLES.indexOf(it.handle) !== -1) { updates[it.key] = 0; }
        });
        var removedCount = Object.keys(updates).length;

        var chain = removedCount
          ? fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ updates: updates })
            }).then(function (r) { if (!r.ok) return Promise.reject(r); return r.json(); })
          : Promise.resolve();

        return chain
          .then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: packVariantId, quantity: 1 })
            });
          })
          .then(function (r) { if (!r.ok) return Promise.reject(r); return r.json(); })
          .then(function () { return normalize(); })
          .then(function () { return { removedCount: removedCount }; });
      });
  }

  function bindPackCtaLinks() {
    document.querySelectorAll('[data-bh-pack-cta]').forEach(function (link) {
      var match = (link.getAttribute('href') || '').match(/^\/cart\/(\d+):(\d+)/);
      if (!match) return;
      var packVariantId = match[1];

      link.addEventListener('click', function (e) {
        if (link.dataset.bhPackCtaLoading) return;
        e.preventDefault();
        link.dataset.bhPackCtaLoading = '1';
        swapToPack(packVariantId)
          .then(function (result) {
            if (result && result.removedCount > 0) { sessionStorage.setItem('bhCartDupNote', '1'); }
            window.location.href = '/cart';
          })
          .catch(function () { window.location.href = '/cart'; });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    refreshBadge();
    bindPackCtaLinks();
  });

  return { fetchCart: fetchCart, normalize: normalize, refreshBadge: refreshBadge, swapToPack: swapToPack };
})();
